import { getLang } from "./getLang";

/**
 * Returns just the root language, excludes country example: `en-US` -> `en`
 */
export const getRootLang = (defaultLng: string): string => {
  const re = /([a-z]*)\W?/i;
  const lang = getLang(defaultLng);
  // getLang returns string, so we can safely use it
  const firstMatch = lang.match(re)?.[1];

  return firstMatch ?? defaultLng;
};
